/**
 * Convert a blob to a DataURL
 */
export function blobToDataURL(blob: Blob): Promise<string> {
  return new Promise(resolve => {
    const a = new FileReader()

    a.onload = event => {
      resolve(event.target?.result?.toString() ?? '')
    }

    a.readAsDataURL(blob)
  })
}
